import {Modal} from "react-bootstrap";
import CatapultLogo from "../../../../assets/catapult_mdl.png";
import ModalClose from "../../../../assets/modal_close.png";
import RecordedVideoSession from "../../../dashboard/components/RecordedVideoSession";
import React from "react";
import YoutubeSession from "../../../dashboard/components/YoutubeSession";

const CommunityGuidelinesModal = ({ onClose, masterClass }) => {

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <Modal onHide={handleClose} show="true" aria-labelledby="contained-modal-title-vcenter" centered dialogClassName="modal-90w" className="add-project-popup">
                <Modal.Header>
                    <img src={CatapultLogo}></img>
                    <div className="modal-close" onClick={handleClose}>
                        <img src={ModalClose}></img>
                    </div>
                </Modal.Header>
                {masterClass?.trailer_url
                    ? <YoutubeSession video={masterClass?.trailer_url} />
                    : <RecordedVideoSession video={masterClass?.trailer_link} />
                }
            </Modal>
        </>
    );
};

export default CommunityGuidelinesModal;